import axios from 'axios'
import cartActions from '../components/cartActions'
import { CartService } from '../utilities/cart'

const cartService = new CartService()

const cart = {
  giftWithPurchase(cart) {
    if (window.gwpEnabled == 'false' || window.gwpProductAvailable !== true || typeof window.gwpProductID === 'undefined') {
      const cartHasGift = cart.items.find(item => item.properties?.isGift)

      if (cartHasGift) {
        const giftID = cartHasGift.variant_id.toString()

        cartService.changeItem(0, giftID).then(() => {
          this.updateCart()
        })
      }

      return;
    }

    const gwpProductID = window.gwpProductID.toString()
    const cartHasGift = cart.items.find(item => item.properties?.isGift)

    if (cartHasGift) {
      const giftID = cartHasGift.variant_id.toString()

      // Gift on Cart is different from the Admin one
      if (giftID !== gwpProductID) {
        cartService.changeItem(0, giftID).then(() => {
          this.updateCart()
        })
      }

      // Multiple Gifts on the Cart
      if (cartHasGift.quantity > 1) {
        cartService.changeItem(1, giftID).then(() => {
          this.updateCart()
        })
      }
    }

    const shouldAddGWP = this.addGWP(cart);

    shouldAddGWP.then(result => {
      if (result && !cartHasGift) {
        cartService.addItem(1, gwpProductID, { isGift: true }).then(() => {
          this.updateCart()
        })
      } else if (!result && cartHasGift) {
        cartService.changeItem(0, gwpProductID).then(() => {
          this.updateCart()
        })
      }
    })
  },

  async addGWP(cart) {
    switch (window.gwpActiveThreshold) {
      case 'price':
        const cartTotalPrice = cart.total_price
        const gwpThresholdCartAmount = Number(window.gwpThresholdCartAmount) * 100

        return cartTotalPrice > gwpThresholdCartAmount
      case 'product':
        const gwpThresholdProduct = window.gwpThresholdProduct

        return cart.items.some(item => item.handle == gwpThresholdProduct)
      case 'collection':
        const gwpThresholdCollection = window.gwpThresholdCollection
        const productPromises = [];
        let addGWP = false;

        cart.items.forEach(item => {
          const fetchPromise = axios.get(`/products/${item.handle}?view=json`)

          productPromises.push(fetchPromise)
        });

        await Promise.all(productPromises).then(res => {
          const allProducts = res.map(productResponse => productResponse.data);

          allProducts.forEach(product => {
            const hasCollection = product.collections.some(collection => collection.handle == gwpThresholdCollection);

            if (hasCollection) {
              addGWP = true
            }
          })

        }).catch(error => console.log(error))

        return addGWP;
      default:
        break;
    }
  },

  updateCart() {
    axios.get('/cart').then(cart => {
      if (document.getElementById('cartTemplate')) {
        var rawData = $(cart.data).find('#cartTemplate').html()

        if (rawData) {
          var encodedData = encodeURIComponent(rawData);
          $('#cartTemplate').html(decodeURIComponent(encodedData))
        }
      } else if (document.getElementById('rebuy-cart')) {
        var rawData = $(cart.data).find("#cartTemplate .cartItems__body").html();

        if (rawData) {
          var encodedData = encodeURIComponent(rawData);
          $("#rebuy-cart #cartItems").html(decodeURIComponent(encodedData));
        } else {
          $("#rebuy-cart #cartItems").html("");
        }
      }
    }).catch(err => {
      console.log(err)
    })
  },

  init() {
    if (document.getElementById('cartTemplate')) {
      cartActions.init()
    }

    window.addEventListener('cartUpdated', () => {
      cartService.getCartData().then((cart) => {
        const count = document.querySelectorAll('.cart_count')

        count.innerHTML = cart.item_count

        if (cart.item_count) {
          count.forEach((el) => {
            el.innerHTML = cart.item_count
            el.classList.remove('empty')
          })
        } else {
          count.forEach((el) => {
            el.innerHTML = 0
            el.classList.add('empty')
          })
        }

        this.giftWithPurchase(cart);
      })
    })
  }
}

export default cart